import { render, staticRenderFns } from "./SiteFtpMode.vue?vue&type=template&id=0ded6f12&scoped=true&"
import script from "./SiteFtpMode.vue?vue&type=script&lang=js&"
export * from "./SiteFtpMode.vue?vue&type=script&lang=js&"
import style0 from "./SiteFtpMode.vue?vue&type=style&index=0&id=0ded6f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded6f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
